
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/processor-partners",
      function () {
        return require("private-next-pages/docs/api/processor-partners.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/processor-partners"])
      });
    }
  